import { createContainer } from "unstated-next";

import useDestinations from "./useDestinations";

export const DestinationsState = createContainer(useDestinations);

DestinationsState.Provider.displayName = "DestinationsState";
